var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdyen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000166660114730377150490000017396038487511872403_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 273.4 273.4",
    style: {
      enableBackground: "new 0 0 273.4 273.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#233C4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,120.9H46.5v8H63c1,0,1.7,0.9,1.7,1.7v14.1h-3.6c-1,0-1.8-0.9-1.8-1.7v-10.2h-6.9 c-3.6,0-6.4,2.9-6.4,6.4v7.1c0,3.6,2.9,6.4,6.4,6.4h25.5v-25.5C77.9,123.8,75,120.9,71.4,120.9L71.4,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102,144.8h-3.6c-1,0-1.7-0.9-1.7-1.7v-22.1h-7c-3.6,0-6.4,2.9-6.4,6.4v19c0,3.6,2.9,6.4,6.4,6.4h25.5v-45.3 h-13.3L102,144.8L102,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,144.8h-3.6c-1,0-1.8-0.9-1.8-1.7v-22.1h-13.3v25.5c0,3.6,2.9,6.4,6.4,6.4h12.3v3.9H121v9.3h25.1 c3.6,0,6.4-2.9,6.4-6.4v-38.7h-13.3V144.8L139.2,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.4,120.9h-25.6v25.5c0,3.6,2.9,6.4,6.4,6.4h25.1v-8H173c-1,0-1.8-0.9-1.8-1.7v-14.1h3.6 c1,0,1.8,0.9,1.8,1.7v10.2h7c3.6,0,6.4-2.9,6.4-6.4v-7.1C190,123.6,187.1,120.8,183.4,120.9L183.4,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.7,120.9h-25.5v31.9h13.4v-24h3.6c1,0,1.8,0.9,1.8,1.7v22.1h13.4v-25.5 C227.1,123.6,224.4,120.8,220.7,120.9L220.7,120.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyen);
export default __webpack_public_path__ + "static/media/Adyen.0fd9dbae3838ba200464c59b3ca48673.svg";
export { ForwardRef as ReactComponent };